import styled from 'styled-components';

export const WrapperConfirmDialog = styled.div`
  padding: 0px 32px 0 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > img {
    margin-bottom: 16px;
  }

  > p {
    color: #161d1f;
    font-size: 14px;
    line-height: 20px;
    text-align: center;

    &:nth-of-type(1) {
      margin-bottom: 8px;
    }

    &:nth-of-type(2) {
      font-size: 16px;
      font-weight: 900;
      line-height: 24px;
    }

    &:nth-of-type(3) {
      margin-top: 40px;
    }
  }
`;
